export default __webpack_public_path__ + "static/media/beauty_2020_OV_seemore_EH-HS99_4_201029.a6ee033f.jpg";